import React, { useState } from "react";
import InputField from "@/app/components/input";
import { RadioGroup } from "../../radio-button";
import Button from "../../button";
import ArrowRight from "../../svg/arrow-right";
import Pin from "../../svg/pin";
import Square from "../../svg/square";
import FloorIcon from "../../svg/floor-icon";
import BackBtnGray from "../../svg/back-btn-gray";

interface Step2Props {
    onNext: (data: any) => void;
    onPrev: () => void;
    initialData: any;
    lang?: string;
    id?: string;
}

const Step2: React.FC<Step2Props> = ({ onNext, onPrev, initialData, lang, id }) => {
    const accept = lang === 'en' ? 'Yes' : 'Ja';
    const notAccept = lang === 'en' ? 'No' : 'Nej';

    const [data, setData] = useState({
        movingTo: initialData.movingTo || "",
        squareMetersTo: initialData.squareMetersTo || "",
        floorTo: initialData.floorTo || "",
        elevator: initialData.elevator || notAccept,
    });

    const [errors, setErrors] = useState({
        movingTo: false,
        squareMetersTo: false,
        floorTo: false,
        elevator: false,
    });

    const handleNext = () => {
        const newErrors = {
            movingTo: !data.movingTo.trim(),
            squareMetersTo: !data.squareMetersTo.trim(),
            floorTo: !data.floorTo.trim(),
            elevator: !data.elevator,
        };

        setErrors(newErrors);

        if (!Object.values(newErrors).some((error) => error)) {
            onNext(data);
        }
    };

    
    const requredText = lang === 'en' ? 'This field is required' : 'Detta fält är obligatoriskt';

    return (
        <div  id={id} className="rounded-[40px] p-[48px] shadow-[0_10px_24px_0_#00000026] max-[576px]:p-[20px] max-[576px]:rounded-[20px]">
            <h2 className="text-[32px] font-bold text-violet-500 mb-[40px] max-[576px]:text-[20px] max-[576px]:leading-[24px] max-[576px]:mb-[24px] ">
                {lang === 'en' ? 'Please fill in the required information' : 'Vänligen fyll i nödvändig information'}
            </h2>
            <div className="space-y-[32px]">
                <div className="grid grid-cols-2 gap-6 max-[767px]:grid-cols-1">
                    <InputField
                        label= {lang === 'en' ? 'Moving To' : 'flytta till'}
                        value={data.movingTo}
                        onChange={(e) => setData({ ...data, movingTo: e.target.value })}
                        errorMessage={errors.movingTo ? requredText : ""}
                        placeholder="Address"
                        iconLeft={<Pin />}
                    />
                    <InputField
                        label={lang === 'en' ? 'number of square meters' : 'antal kvadratmeter'}
                        value={data.squareMetersTo}
                        type="number"
                        onChange={(e) => setData({ ...data, squareMetersTo: e.target.value })}
                        errorMessage={errors.squareMetersTo ? requredText : ""}
                        iconLeft={<Square />}
                    />
                </div>
                <div className="grid grid-cols-2 gap-6 max-[767px]:grid-cols-1">
                    <div className="mt-[28px] max-[576px]:mt-[0]">
                        <InputField
                            label={lang === 'en' ? 'write the floor' : 'Våning'}
                            value={data.floorTo}
                            placeholder= {lang === 'en' ? 'Please write the floor' : 'Våning'}
                            iconLeft={<FloorIcon />}
                            onChange={(e) => setData({ ...data, floorTo: e.target.value })}
                            errorMessage={errors.floorTo ? requredText : ""}
                            type="number"
                        />
                    </div>
                    <div>
                        <h3 className="font-medium text-sm text-violet-500 leading-[143%] uppercase mb-[8px] max-[767px]:text-[12px] max-[576px]:leading-[12px]">
                            {lang === 'en' ? 'Elevator?' : 'Finns hiss?'}
                        </h3>
                        <RadioGroup
                            name="elevator"
                            mobileWidth="1/2"
                            options={[
                                { id: "yes", label: accept, value: accept },
                                { id: "no", label: notAccept, value: notAccept },
                            ]}
                            selectedValue={data.elevator}
                            onChange={(value) => setData({ ...data, elevator: value })}
                        />
                        {errors.elevator && <span className="text-red-500 text-sm">{requredText}</span>}
                    </div>
                </div>
            </div>
            <div className="flex justify-between mt-[40px] max-[767px]:flex-wrap max-[767px]:justify-center  max-[767px]:gap-[24px] max-[767px]:mt-[24px]">
                <Button 
                    onClick={onPrev} 
                    text={lang === 'en' ? 'Back' : 'tillbaka'}
                    type="secondary" 
                    icon={<BackBtnGray />}
                    size="big"
                />
                <Button
                    onClick={handleNext}
                    text={lang === 'en' ? 'continue' : 'fortsätta' }
                    icon={<ArrowRight />}
                    type="primary"
                    iconPostiton="right"
                    size="big"
                />
            </div>
        </div>
    );
};

export default Step2;